<template>
  <div class="pin-answer-card">
    <div class="pin-header">
      <div class="pin-icon">
        <i class="el-icon-collection-tag" style="font-weight: bold; color: #e6a23c;"></i>
        <span>Pinned Card</span>
        <span class="dot">•</span>
        <span class="timestamp">{{ formattedTimestamp }}</span>
      </div>
      <div class="pin-actions">
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="text" size="mini" class="more-btn">
            <i class="el-icon-more"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="remove">
              <i class="el-icon-delete"></i> Remove
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="pin-content">
      <div class="answer-preview">
        <div class="answer-content" @click="viewPost">
          <div v-if="pinAnswer.answer.contentType === 'text'" v-html="pinAnswer.answer.content"></div>
          <div v-else-if="pinAnswer.answer.contentType === 'image'" class="image-content">
            <img :src="pinAnswer.answer.content" alt="Pinned image" style="max-width: 100%; height: auto; border-radius: 4px;">
          </div>
          <div v-else-if="pinAnswer.answer.contentType === 'video'" class="video-content">
            <video controls style="max-width: 100%; height: auto; border-radius: 4px;">
              <source :src="pinAnswer.answer.content" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <div v-else-if="pinAnswer.answer.contentType === 'quiz'" class="quiz-content">
            <p>{{ pinAnswer.answer.quiz_content.question }}</p>
          </div>
          <div v-else>
            <p>{{ pinAnswer.answer.content }}</p>
          </div>
        </div>

      </div>

      <div class="post-info-section">
        <div class="stack-header">
          <div class="stack-header-left">
            <span class="stack-label">From the stack</span>
            <span class="dot">•</span>
            <span class="author-wrapper">
              <span class="author-label">by</span>
              <el-avatar :size="16" class="author-avatar" style="font-size: 10px;">{{ pinAnswer.answer.author?.charAt(0) || 'U' }}</el-avatar>
              <span class="author-name">{{ pinAnswer.answer.author }}</span>
            </span>
            <span class="dot">•</span>
            <span class="answer-index">Card #{{ pinAnswer.answer.answerIndex + 1 }}</span>
          </div>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-view"
            @click="viewPost"
            class="view-btn"
          >
            View the Stack
          </el-button>
        </div>
        <div class="post-info-content">
          <h3 class="post-info-title" @click="viewPost">{{ pinAnswer.answer.postTitle }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinAnswerCard',
  props: {
    pinAnswer: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedTimestamp() {
      const date = new Date(this.pinAnswer.timestamp)
      const now = new Date()
      const diffInHours = Math.floor((now - date) / (1000 * 60 * 60))

      if (diffInHours < 1) {
        return 'Just now'
      } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
      } else {
        const diffInDays = Math.floor(diffInHours / 24)
        if (diffInDays <= 10) {
          return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
        } else {
          const month = date.toLocaleString('en-US', { month: 'short' })
          const day = date.getDate()
          const year = date.getFullYear()
          const currentYear = now.getFullYear()

          if (year === currentYear) {
            return `${month} ${day}`
          } else {
            return `${month} ${day}, ${year}`
          }
        }
      }
    }
  },
  methods: {
    viewPost() {
      if (this.pinAnswer.answer.collection_id) {
        this.$router.push({
          path: '/read-collection',
          query: { collection_id: this.pinAnswer.answer.collection_id }
        })
      } else {
        this.$router.push({
          path: '/stack',
          query: {
            id: this.pinAnswer.answer.postId,
            cardIndex: this.pinAnswer.answer.answerIndex
          }
        })
      }
    },
    handleCommand(command) {
      if (command === 'remove') {
        this.$emit('remove', this.pinAnswer.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pin-answer-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid #e6a23c;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #dee2e6;
  }
}

.pin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.pin-icon {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: #e6a23c;
  }

  > span {
    font-weight: 600;
    color: #e6a23c;
    font-size: 14px;
  }

  .dot {
    color: #adb5bd;
    font-size: 14px;
    font-weight: normal;
  }

  .timestamp {
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;
  }
}

.pin-actions {
  display: flex;
  gap: 8px;
  
  .view-btn {
    color: #1159AF;
    font-size: 12px;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .remove-btn {
    color: #6c757d;
    font-size: 12px;
    
    &:hover {
      color: #dc3545;
    }
  }
}

.pin-content {
  .post-info-section {
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 6px;
    margin-top: 16px;

    .stack-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #dee2e6;

      .stack-header-left {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;

        .stack-label {
          font-size: 12px;
          font-weight: 600;
          color: #6c757d;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .dot {
          color: #adb5bd;
          font-size: 12px;
        }

        .author-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          color: #6c757d;

          .author-label {
            font-size: 12px;
          }

          .author-avatar {
            flex-shrink: 0;
          }

          .author-name {
            font-size: 12px;
          }
        }

        .answer-index {
          background-color: #fff;
          padding: 2px 6px;
          border-radius: 4px;
          font-weight: 500;
          font-size: 12px;
          color: #6c757d;
        }
      }

      .view-btn {
        color: #1159AF;
        font-size: 12px;
        flex-shrink: 0;

        &:hover {
          color: #409EFF;
        }
      }
    }

    .post-info-content {
      .post-info-title {
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;
        margin: 0 0 8px 0;
        cursor: pointer;
        line-height: 1.4;

        &:hover {
          color: #1159AF;
        }
      }

      .post-meta {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #6c757d;

        .dot {
          color: #adb5bd;
        }

        .answer-index {
          background-color: #fff;
          padding: 2px 6px;
          border-radius: 4px;
          font-weight: 500;
        }
      }
    }
  }

  .answer-preview {
    .answer-content {
      margin-bottom: 12px;
      cursor: pointer;
      font-size: 14px;
      color: #495057;
      line-height: 1.6;

      &:hover {
        color: #2c3e50;
      }
    }
    
    .answer-excerpt {
      margin-bottom: 12px;
      
      p {
        font-size: 14px;
        color: #495057;
        margin: 0;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      
      .image-content, .video-content {
        margin: 8px 0;
      }
      
      .quiz-content {
        p {
          margin: 4px 0;
        }
      }
    }
    
    .answer-stats {
      display: flex;
      gap: 16px;
      
      .stat-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        color: #6c757d;
        
        i {
          font-size: 14px;
          color: #67c23a;
        }
      }
    }
  }
}
</style> 